export default __webpack_public_path__ + "static/media/icon-arrowdown-gray.bbd5161d.svg";